import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import useExtendedMutation from '../../hooks/useExtendedMutation';
import {
    ALL_AUCTIONS_QUERY_NAME,
    AUCTION_DETAIL,
    REOPEN_AUCTION,
} from '../../graphql/auctions';
import { auctionType as auctionTypeRef } from '../../types';
import {
    CLOSED,
    getUIPhase,
} from '../../utils/AuctionPhase';
import MutationButton from '../buttons/MutationButton';
import ClosureTimeProvider from './ClosureTimeProvider';

AuctionReopenButton.propTypes = {
    auction: auctionTypeRef.isRequired,
    disabled: PropTypes.bool,
};

function AuctionReopenButton(props) {
    const {
        auction,
        disabled = false,
    } = props;
    const { t } = useTranslation();
    const uiPhase = getUIPhase(auction.phase);
    const reopenAuctionMutation = useExtendedMutation(REOPEN_AUCTION, {
        variables: { id: auction.id },
        successMessageOptions: { key: 'auctions.notification.auction-reopen-success', dataProperty: 'reopenAuction' },
        failureMessageOptions: { key: 'auctions.notification.auction-reopen-failure', params: { name: auction.name } },
        refetchQueries: [ALL_AUCTIONS_QUERY_NAME, {
            query: AUCTION_DETAIL,
            variables: {
                auctionId: auction.id,
            },
        }],
    });
    const variablesComponent = (setVariables, setValid) => (
        <ClosureTimeProvider
            setVariables={setVariables}
            setValid={setValid}
        />
    );
    return (
        uiPhase.is(CLOSED) && (
            <MutationButton
                className="reopen-auction button-bordered-orange button"
                confirmationMessage={t('auctions.confirm-reopen-auction', { name: auction.name })}
                extraConfirmationMessage={t('auctions.extra-confirm-reopen-auction', { name: auction.name })}
                extendedMutation={reopenAuctionMutation}
                disabled={disabled}
                variablesComp={variablesComponent}
            >
                <FontAwesomeIcon icon="undo" />&nbsp;{t('auctions.reopen-auction')}
            </MutationButton>
        )
    );
}

export default AuctionReopenButton;
